import {
  ROUTE_NAME_CUSTOMER_VEHICLE_TRACKING,
} from '@/config/routeNames';

/** Page principale de l'application */
export const CUSTOMER_VIEW = 'customer-view';
export const CUSTOMER_STATUS_BOX = 'customer-status-box';
export const CONTENT = 'page-content';

/**
 * Page d'accueil
 */
export const HOME_NEXT_TRIPS = 'home-next-trips';
export const HOME_REALTIME = 'home-realtime';
export const HOME_REALTIME_BOX = 'home-realtime-box';
export const HOME_REALTIME_NO_DATA = 'home-realtime-empty-no-data';

/**
 * Page "Mon Profil"
 */
export const PROFILE_CARD = 'profile-card';
export const PROFILE_CARD_ITEM_NOTE = 'infocard-item-note';
export const CHANGE_PASSWORD_FORM = 'change-password-form';

/**
 * Page Mes déplacements (occasionnels ('dated') et réguliers ('template'))
 */
export const CUSTOMER_TRIPS_NAVIGATION = 'customer-trips-navigation';
export const CUSTOMER_TRIPS_DATED_VIEW = 'customer-trips-dated-view';
export const CUSTOMER_TRIPS_DATED_CONTAINER = 'customer-trips-dated-container';
export const CUSTOMER_TRIPS_TEMPLATE_VIEW = 'customer-trips-template-view';
export const TRIPS_DATED_DATE_SELECTOR = 'trips-dated-date-selector';
export const TRIPS_TEMPLATE_DAY_SELECTOR = 'trips-template-day-selector';

export const CUSTOMER_TRIPS_DATED_EMPTY = 'trips-empty';
export const CUSTOMER_TRIPS_TEMPLATE_EMPTY = 'trips-empty';
export const TRIPS_CONTENT = 'customer-trips-content';
export const CONTENT_HEADER = 'trips-header';
export const TRIPS_CARD = 'customer-trip-card';
export const TRIP_NODE_LOCATION = 'trip-node-location';
export const TRIP_DETAILS_CARD = 'trip-details-card';
export const TRIP_DETAILS_ASYNC_ERROR_MESSAGE = 'trip-details-async-error-message';
export const TRIP_DETAILS_BACK_BUTTON = 'trip-details-back-button';
export const TRIP_DETAILS_CANCEL_TRIP_BUTTON = 'trip-details-cancel-trip-button';
export const TRIP_DETAILS_MODIFY_TRIP_BUTTON = 'trip-details-modify-trip-button';
export const TRIP_DETAILS_SEND_EMAIL_BUTTON = 'trip-details-send-email';
export const INTERRUPTION_MODAL = 'trip-interruption-modal';
export const INTERRUPTION_FORM_ITEM = 'interruption-form-item';
export const TRIP_DETAILS_INTERRUPTION_BUTTON = 'trip-details-suspend-trip-button';
export const CANCEL_TRIP_LEG = 'trip-details-cancel-trip-leg';
export const BATCH_CANCEL_TRIPS_BUTTON = 'batch-cancel-trips-button';
export const MODAL_CONFIRMATION_REQUEST = 'modal-confirmation-request';
export const MODAL_CONFIRMATION_TEXT = 'modal-confirmation-text';
export const MODAL_TRIP_CANCELLATION = 'cancel-trips-modal';

export const modals = {
  CANCEL_TRIP_LEG: 'modal-cancel-trip-leg',
  TRIP_SEND_EMAIL: 'modal-trip-send-email',
};

export const statusBoxes = {
  HISTORY_FORM: 'history-form',
  TRIP_SEND_EMAIL: 'trip-send-email',
  TRIP_INTERRUPTION: 'trip-interruption',
  TRIPS_CANCELLATION: 'trips-cancellation',
  MODIFY_DEVICES: 'modify-devices',
  MODIFY_CUSTOMER_INFOS: 'modify-customer-infos',
  CHANGE_PASSWORD: 'change-password',
  REALTIME_MISSING_BOX: 'realtime-missing-box',
  FAVOURITE_ADDRESSES: 'favourite-addresses',
  DELETE_FAVOURITE_ADDRESS: 'delete-favourite-address',
  FINISH_RESERVATION: 'finish-reservation',
};

/**
 * Page "Suivre mon véhicule
 */
export const TRACK_VEHICLE_PAGE = ROUTE_NAME_CUSTOMER_VEHICLE_TRACKING;

/**
 * Page historique
 */
export const HISTORY_FORM_ITEM = 'history-form-item';
export const HISTORY_LIST_CONTAINER = 'history-list-container';
export const HISTORY_TRIP_CARD = 'history-trip-card';
